/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Agensi_O3Inputs */

const en_mk_sol_agensi_o3 = /** @type {(inputs: Mk_Sol_Agensi_O3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The brand voice holds even when a different person does the work`)
};

const id_mk_sol_agensi_o3 = /** @type {(inputs: Mk_Sol_Agensi_O3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada brand tetap sama meski yang mengerjakan berganti`)
};

/**
* | output |
* | --- |
* | "The brand voice holds even when a different person does the work" |
*
* @param {Mk_Sol_Agensi_O3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_agensi_o3 = /** @type {((inputs?: Mk_Sol_Agensi_O3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Agensi_O3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_agensi_o3(inputs)
	return en_mk_sol_agensi_o3(inputs)
});